import React, { useState, useEffect } from 'react';
import validator from 'validator';
import axios from 'axios';
import { defaultVariables } from '../../../../config/index';
import { connect } from "trim-redux";
import {InputAdornment} from "@mui/material";
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid2';
import LoadingButton from "../../../components/elements/LoadingButton";
import { Styles } from '../../../../config/design/styles';
import {useSnackbar} from "notistack";
import CssBaseline from "@mui/material/CssBaseline";
import AppCardLoaderFields from "../../../components/loaders/AppCardLoaderFields";
import {useNavigate} from "react-router-dom";
import FieldCounter from "../../../components/elements/fields/FieldCounter";
import SingleImageChooser from "../../fileManager/Components/SingleImageChooser";
import SubTitle from "../../../components/elements/SubTitle";
import {useParams} from "react-router";
import {useTranslation} from "react-i18next";
import RayaField from "../../../components/elements/fields/RayaField";
import RichEditor from "../../../components/editor/RichEditor";
import BannersManager from "../setting/banners/BannersManager";
import EditableJsonComponent from "../../../components/elements/fields/EditJsonField";

const MakePage = (props) => {
    const { classes } = props;
    const navigation = useNavigate();
    const { t } = useTranslation();

    let { id } = useParams();

    const [fields, setFields] = useState({
        name: '',
        description: '',
    });
    const [content, setContent] = useState({
        HTML: '',
        RAW: null,
        PlainText: '',
        slug: ''
    });
    const [thumbnail, setThumbnail] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const [strings, setStrings] = useState(null);
    const [page, setPage] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const loadData = async () =>{
        await setLoading(true);
        await axios.get(`${defaultVariables.url}/pages/get/${id}`,config)
            .then(response => {
                setFields({
                    name: response.data.name,
                    description: !!response.data.description ? response.data.description : '',
                    slug: !!response.data.slug ? response.data.slug : '',
                });
                setContent({
                    HTML: response.data.html,
                    RAW: response.data.raw,
                })
                setThumbnail(response.data.thumbnail)
                setStrings(response.data.strings)
                setPage(response.data)
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching match data:", error);
                setLoading(false); // Set loading to false even if there is an error
            });
    }
    useEffect(() => {
        if(!!id){
            loadData();
            setEditMode(true);
        }else{
            setLoading(false);

        }
    }, [id]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFields((prevFields) => ({ ...prevFields, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
    const handleInputChange = (fieldName, value) => {
        setFields((prevFields) => ({
            ...prevFields,
            [fieldName]: value,
        }));
    };
    const handleValidation = async (callback) => {
        let formIsValid = true;
        let newErrors = {};

        // Validation for full_name
        if (validator.isEmpty(fields.name)) {
            formIsValid = false;
            newErrors.name = t('emptyField');
        }

        setErrors(newErrors);
        if (!formIsValid) setSubmitLoading(false);
        callback(formIsValid);
    };

    const handleRequest = async () => {

        const data = new FormData();
        data.append('name', fields.name);
        data.append('description', fields.description);
        data.append('html', content.HTML);
        data.append('raw', content.RAW);
        data.append('planText', content.PlainText);
        data.append('file_id', !!thumbnail ? thumbnail.id : '');
        if(!!id){
            data.append('item_id', id);
        }
        if(!!strings){
            data.append('strings', JSON.stringify(strings));

        }
        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            await axios.post(`${defaultVariables.url}/pages/make`, data, config);
            enqueueSnackbar(t('detailsSet'), { variant: 'success' });
            setSubmitLoading(false);
            navigation(`/panel/manage/pages/view-all`);

        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);
            if(error.response.status === 403){
                enqueueSnackbar(t('duplicateProductName'), { variant: 'warning' });
            }else{
                enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });

            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) handleRequest();
        });
    };

    if (loading) {
        return <AppCardLoaderFields />;
    }
    return (
        <Grid container spacing={2} justify="center" >
            <CssBaseline />
            {/*<Grid item size={{xs:12}} className="imageChooserHolder">
                <SubTitle align="left">{t('thumbnail')}</SubTitle>
                <SingleImageChooser
                    primary
                    onChange={(thumbnail) => setThumbnail(thumbnail)}
                    initial={thumbnail}
                    width={150}
                />
            </Grid>*/}
            <Grid item size={{xs:12}}>
                <RayaField
                    variant="outlined"
                    required
                    fullWidth
                    label={t('pageName')}
                    name="name"
                    value={fields.name}
                    onChange={handleChange}
                    error={!!errors.name}
                    helperText={errors.name}
                />
            </Grid>

            {
                (!editMode || !!page.has_editor) &&
                <>
                    <Grid item size={12}>
                        <RayaField
                            variant="outlined"
                            multiline
                            fullWidth
                            name="description"
                            label={t('description')}
                            type="text"
                            id="description"
                            className={classes.inputCtl}
                            rows="4"
                            value={fields.description}
                            onChange={handleChange}
                            error = {!!errors['description']}
                            helperText={errors['description']}
                            slotProps={{
                                input:{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <FieldCounter length={fields.description.length} max={1000}/>
                                        </InputAdornment>
                                    ),
                                }
                            }}
                        />
                    </Grid>
                    <Grid item size={12}>
                        <RichEditor
                            Output={(content) => setContent(content)}
                            input={content.RAW}
                        />
                    </Grid>

                    {
                        !!id &&
                        <Grid item size={12}>
                            <SubTitle align="left" color="text">{t('page_banners')}</SubTitle>
                            <BannersManager position={`${fields.slug}_banners`} page/>
                        </Grid>
                    }
                </>

            }
            {
                (!!editMode && !!page.has_strings) &&
                <>
                    <EditableJsonComponent initialJson={strings} setResult={(result) => setStrings(result)} />
                </>
            }

            <Grid item size={12}>
                <LoadingButton
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    loading={submitLoading}
                >
                    {t('setDetails')}
                </LoadingButton>
            </Grid>

        </Grid>
    );
};

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user
});

export default withStyles(Styles)(connect(mstp)(MakePage));
